import { ROUTE_STROKE_WIDTH } from "../CircuitPathsLayer/constants";

export const SEGMENT_HIT_STROKE_WIDTH = ROUTE_STROKE_WIDTH * 3;
export const HOVER_LINE_DASH_ARRAY = `3 ${ROUTE_STROKE_WIDTH * 2}`;
export const CREATION_RGB: [number, number, number] = [59, 130, 246];

/** Scales the standard `size / 2` node radius to match `DestinationMarker`'s halo. */
export const NODE_RADIUS_FACTOR = 1.4;
/** Selection halo drawn around the currently-grabbed node. */
export const SELECTED_NODE_HALO_FACTOR = 1.4;
export const SELECTED_NODE_HALO_STROKE = "rgb(220, 38, 38)";
/** Soft same-color glow rendered under the active route's line. */
export const ACTIVE_BLOOM_STROKE_WIDTH = ROUTE_STROKE_WIDTH * 1.7;
export const ACTIVE_BLOOM_OPACITY = 0.18;
